import type { Lock, LockResponse } from 'containers/Warehouse/MagAccess/popups/CodePreview'
import ArrowBtn from 'components/buttons/ArrowBtn'
import React, { useEffect, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import Popup from 'components/popups/Popup'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'
import '../style.scss'

interface ReportProblemModalProps {
  warehouseId: string
  contractId: string
}

const ReportProblemModal: React.FC<ReportProblemModalProps> = ({ warehouseId, contractId }) => {
  const [code, setCode] = useState<string | undefined>('')
  const [isLoading, setLoading] = useState(true)

  const { replace } = useHistory()
  const { t } = useTranslation('entrance')
  const getContracts = async (ids: string[]) => {
    setLoading(true)
    try {
      const response: LockResponse = await POST(urls.contracts, { body: { ids } })
      if (response?.locks?.[0]?.warehouseId) {
        setCode(findGateCode(response.locks[0]))
        setLoading(false)
      } else {
        throw new Error('Wrong response')
      }
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getContracts([contractId])
  }, [contractId])

  return (
    <Popup centered>
      <div className='reportProblem__modal'>
        <div className='popup__title'>
          <div>{t('gateWontOpen')}</div>
        </div>
        <p>{t('tryEnteringPinOnKeypad')} <span>{t('confirmWithHash')}</span></p>
        <div className='reportProblem__code'>
          {isLoading
            ? <Skeleton className='reportProblem__code--skeleton' />
            : code
              ? <span className='reportProblem__code--text'>{code}</span>
              : <span>{t('failedToDownloadCode')}</span>}
        </div>
        <ArrowBtn
          enlarged
          showArrow={false}
          text={t('reportGateIssue')}
          action={() => {
            replace(`/help?warehouseId=${warehouseId}`)
          }}
        />
        <BackBtn
          text={t('gateOpenedSuccessfully')}
        />
      </div>
    </Popup>
  )
}

const findGateCode = (lock: Lock) => {
  for (const page of lock.pages) {
    if (page.img === 'gate') {
      const section = page.sections.find(section => section.type.includes('pin'))
      if (section) {
        return section.content
      }
    }
  }
}

export default ReportProblemModal